export const Highlighter = (keyword, string) => {
	const className = "highlight";
	let words=[];
	if(keyword!==null && keyword !==undefined){
		words = keyword.split(" ");
	}
	for (let i = 0; i < words.length; i++) {
		if (words[i] !== "") {
			const startPoint = string.indexOf(words[i]);
			const endPoint = words[i].length + startPoint;
			if (startPoint !== -1) {
				let theFirst = string.substring(0, startPoint);
				let theWord = string.substring(startPoint, endPoint);
				const theRest = string.substring(endPoint, string.length + endPoint);

				const reg = /^[a-z]+$/i;
				let zwjAtTheFirst = (!reg.test(theFirst.split(" ")[0])) ? '' : '&zwj;';
				zwjAtTheFirst = (theFirst.split(" ")[0] === '') ? '' : '&zwj;';
				let zwjAtTheEnd = (theRest.split(" ")[0] === '') ? '' : '&zwj;';

				theWord = `${zwjAtTheFirst}<span class="${className}">${zwjAtTheFirst}${theWord.toString()}${zwjAtTheEnd}</span>${zwjAtTheEnd}`;
				string = theFirst.toString() + theWord.toString() + theRest.toString();
			}
		}
	}
	return string;
};